module.exports = __webpack_public_path__ + "static/media/no_vouchers.1379d713.png";